import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon, { GLYPHS } from '../../../common/icon';
import { TIME_TRACKING_ROLES } from '../../constants';
import { t } from '../../../../modules/infra/i18n';
import get from 'lodash/get';

const BarberListTimeTracking = ({ clockedTime, active, onClick, busyIsOn, barberRole, extendedHourlyWages }) => {
  const roleTitle = get(TIME_TRACKING_ROLES, [barberRole, 'label'], '');
  const clockOutText = extendedHourlyWages 
    ? t('barber:time_tracking.clock_out_with_role', { role: roleTitle })
    : t('barber:time_tracking.clock_out');

  return (
    <div className="c-table-card__cell u-2/10 u-text-right">
      <Icon
        glyph={GLYPHS.stopwatch}
        size="small"
        className={classnames('o-icon--small o-icon--pointer', active ? 'u-font-color-green' : 'u-font-color-red')}
      />
      <div className="u-mr- u-align-middle u-width-70 u-inline-block">{clockedTime}</div>
      <button
        disabled={busyIsOn}
        onClick={onClick}
        className="c-btn c-btn--default c-btn--small"
        style={{ width: '175px' }}
      >
        {active ? clockOutText : t('barber:time_tracking.clock_in')}
      </button>
    </div>
  );
};
BarberListTimeTracking.propTypes = {
  clockedTime: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  busyIsOn: PropTypes.bool.isRequired,
  extendedHourlyWages: PropTypes.bool.isRequired,
  barberRole: PropTypes.string.isRequired,
};
BarberListTimeTracking.defaultProps = {
};

export default BarberListTimeTracking;
